<template>
  <one-column-layout :loading="!loaded">

    <title-bar :title="title" slot="titleBar">
      <div class="smd-spacer"/>

      <smd-btn icon="smd-icon-action-close" @click="close"/>
    </title-bar>

    <two-column-layout class="sb-min-180 hide-sidebar">
      <title-bar class="space-s-l" type="page" slot="sidebar">
        <smd-btn clean class="icon-text" @click="back">
          <i class="smd-icon-arrow-left"/>
          <label dark-normal>Back</label>
        </smd-btn>
      </title-bar>



        <one-column-layout class="space-l max-1000 flex-start" slot="content">
          <title-bar title="Personal Information" type="page" slot="titleBar">
            <div class="smd-spacer"/>
            <smd-btn @click.prevent="savePatientInfo">Save</smd-btn>
          </title-bar>

          <div class="form">
            <div>
              <div class="form__row--x">
                <label>First Name</label>
                <input type="text" placeholder="e.g. John" v-model="patient.firstName">
              </div>
              <div class="form__row--x">
                <label>Middle Name</label>
                <input type="text" placeholder="e.g. Zarks"  v-model="patient.middleName">
              </div>
              <div class="form__row--x">
                <label>Last Name</label>
                <input type="text" placeholder="e.g. Doe"  v-model="patient.lastName">
              </div>
              <div class="form__row--x">
                <label>Date of Birth</label>
                <smd-date-input v-model="patient.birthDate"/>
              </div>
              <div class="form__row--x" v-if="isPediatric">
                <label>Confirm that patient is {{computeAge}} years of age and considered a pediatric case?</label>
                <smd-segment type="pill"
                             v-model="confirmPediatric"
                             :items="$options.booleanChoices"/>
              </div>
            </div>
          </div>
        </one-column-layout>

    </two-column-layout>

  </one-column-layout>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from 'vuex'
  import Moment from 'moment'
  import { MUTATE_SHOW_OVERLAY } from '../../../store/modules/shared'
  import {
    ACTION_ADD_PATIENT,
    ACTION_SAVE_PATIENT,
    GETTER_SELECTED_PATIENT,
    ACTION_LOAD_PATIENT_INFO
  } from '../../../store/modules/patients'
  import Routes from '../../../router/route-constants'

  export default {
    data(){
      return{
        loaded: false,
        patient: {
          firstName  : null,
          lastName   : null,
          middleName : null,
          avatar     : null,
          birthDate  : null
        },
        confirmPediatric: false
      }
    },
    computed: {
      ...mapGetters({
        selectedPatient: GETTER_SELECTED_PATIENT
      }),
      isNew() {
        return this.$route.name === Routes.ROUTE_NEW_PATIENT
      },
      title(){
        return this.isNew ? "New Patient" : "Edit Patient"
      },
      computeAge() {
        return this.patient.birthDate ? this.getAge(this.patient.birthDate, new Date()) : 100
      },
      isPediatric() {
        return this.computeAge < 19
      }
    },
    methods:{
      ...mapMutations({
        showOverlay: MUTATE_SHOW_OVERLAY
      }),
      ...mapActions({
        addPatient : ACTION_ADD_PATIENT,
        editPatient: ACTION_SAVE_PATIENT
      }),
      getAge(date, fromDate) {
        let today = fromDate;
        let birthDate = new Date(date);
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
        {
          age--;
        }
        return age;
      },
      savePatientInfo(){

        if (this.isPediatric && !this.confirmPediatric) { this.$toasted.show("Please confirm that patient is a pediatric case."); return; }
        // Check if valid
        if (!this.patient.firstName) { this.$toasted.show("First name is required"); return; }
        if (!this.patient.birthDate) { this.$toasted.show("Enter a valid birthdate"); return; }

        let data = {
          patientid : this.patient._id,
          firstName : this.patient.firstName,
          middleName: this.patient.middleName,
          lastName  : this.patient.lastName,
          avatar    : this.patient.avatar,
          birthDate : this.patient.birthDate
        };
        //
        // if(!data.firstName){
        //   this.$toasted.show('Firstname is required');
        //   return;
        // }

        let promise = this.isNew ? this.addPatient(data) : this.editPatient(data)
        promise.then(this.afterSavePatientInfo(this.isNew))
          .catch((err) => {
            this.$toasted.show(err.message);
          });


      },
      afterSavePatientInfo(isNew) {
        return (data) => {
          this.displayToast();
          if (isNew) {
            this.$router.push({name: Routes.ROUTE_NEW_PATIENT_CASE, params: { patientid: data._id }});
          } else {
            this.$router.push({name: Routes.ROOT_ROUTE_PATIENTS});
          }
        }
      },
      back(){
        this.showOverlay(true);
        this.$router.push({name: Routes.ROOT_ROUTE_PATIENTS});
      },
      close(){
        this.showOverlay(false);
        this.$router.push({name: Routes.ROOT_ROUTE_PATIENTS});
      },
      init(patientid) {
        if (!this.isNew) {
          this.$store.dispatch(ACTION_LOAD_PATIENT_INFO, patientid).then( () => {
            this.patient = this.selectedPatient.info;
            this.loaded = true;
          })
        } else {
          this.loaded = true
        }
      },
      displayToast(){
        const message = this.isNew ?
          'Successfully added new patient!' :
          'Successfully updated patient information!';
        this.$toasted.show(message);
      }
    },
    beforeRouteEnter(to,from,next) {
      next(vm => {
        vm.init(to.params.patientid)
      })
    },
    booleanChoices: [
      {id: 1, name: 'YES', val: true},
      {id: 2, name: 'NO', val: false}
    ]
  }
</script>

<style lang="scss">

  @import "../../../scaffolding/scss/pogs-util";

  .form.new-patient{
    @include make-grid-cols(150px 1fr, space(m));

    & > div:first-child{
      @extend %flex-col, %align-items-center;
    }

    .form__row--x{
      max-width: 80%;
    }
  }

</style>
